<template>
  <div class="grid gap-5">
    <div class="flex items-center justify-between">
      <div class="text-xl font-bold dark:text-white light:text-light-text">
        인기 게임
      </div>
      <div class="flex items-center gap-2">
        <QBtn
          icon="chevron_left"
          unelevated
          flat
          dense
          :disable="index === 0"
          class="dark:bg-dark-2 light:bg-light-2"
          @click="swiper.slideTo(getMoveIndex('pre'))"
        />
        <QBtn
          icon="chevron_right"
          unelevated
          flat
          dense
          :disable="index === games.length - slidesPerView"
          class="dark:bg-dark-2 light:bg-light-2"
          @click="swiper.slideTo(getMoveIndex('next'))"
        />
      </div>
    </div>
    <div class="overflow-hidden">
      <Swiper
        :slides-per-view="$q.screen.gt.sm ? 7 : 2"
        space-between="10"
        @init="initSwiper"
        @slideChange="onSlideChange"
      >
        <SwiperSlide v-for="game in games">
          <div class="dark:(text-white bg-dark-2) light:(text-light-text bg-light-2) flex flex-col gap-2 rounded-3xl overflow-hidden ">
            <img
              :src="game.img"
              width="180"
              height="180"
            >
            <div class="p-2 flex flex-col justify-between gap-4">
              <div class="w-full flex items-center justify-between">
                {{ game.name }}
                <ImgIcon
                  :src="icon"
                  size="18px"
                />
              </div>
              <QBtn
                :to="game.route"
                unelevated
                label="지금 게임하기"
                text-color="white"
                class="bg-gradient-primary h-12 w-30 text-sm font-bold"
              />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import {computed, ref} from 'vue'
import { useCycleList } from '@vueuse/core'
import ImgIcon from '@/components/Icons/ImgIcon.vue'
import icon from '@/assets/home/games/icon.svg'
import link1 from '@/assets/home/games/link-1.png'
import link2 from '@/assets/home/games/link-2.png'
import link3 from '@/assets/home/games/link-3.png'
import link4 from '@/assets/home/games/link-4.png'
import link5 from '@/assets/home/games/link-5.png'
import link6 from '@/assets/home/games/link-6.png'
import link7 from '@/assets/home/games/link-7.png'
import {useQuasar} from 'quasar'

const games = [
  {
    img: link1,
    name: '에볼루션',
    route: {name: 'casinos.play', params: { id: 1, code: 'top_games' }}
  },
  {
    img: link2,
    name: '룰렛',
    route: {name: 'lottery.wheel'}
  },
  {
    img: link3,
    name: '슬롯',
    route: {name: 'slots'}
  },
  {
    img: link4,
    name: '토큰게임',
    route: ''
  },
  {
    img: link5,
    name: '가상축구',
    route: { name: 'virtual-games'}
  },
  {
    img: link6,
    name: '그래프게임',
    route: { name: 'pragmatic', params: { id: 33, code: 1302 } }
  },
  {
    img: link7,
    name: '미니게임',
    route: { name: 'mini-games'}
  },
]
const $q = useQuasar()
const swiper = ref(null)
const slidesPerView = computed(() => { return $q.screen.gt.sm ? 7 : 2})
const { index } = useCycleList(games)

function initSwiper (instance) {
  swiper.value = instance
}

function getMoveIndex(type){
  if (type === 'pre'){
    return index.value - slidesPerView.value < 0 ? 0 : index.value - slidesPerView.value
  }else{
    return index.value + slidesPerView.value > games.length - slidesPerView.value ? games.length - slidesPerView.value : index.value + slidesPerView.value
  }
}

function onSlideChange(instance){
  index.value = instance.activeIndex
}
</script>
